const TICK_MS = 60_000;

type Listener = () => void;

const listeners = new Set<Listener>();
let intervalId: ReturnType<typeof setInterval> | null = null;

function tick() {
  listeners.forEach((listener) => listener());
}

/**
 * Pulso de 1 minuto compartilhado por todos os assinantes — um único
 * `setInterval` na página, não um por avatar renderizado. Sobe o timer no
 * primeiro assinante, derruba no último.
 */
export function subscribeToPresenceClock(listener: Listener): () => void {
  listeners.add(listener);
  if (!intervalId) intervalId = setInterval(tick, TICK_MS);

  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };
}
